var map = {
	"./calendar.svg": 590,
	"./close.svg": 7544,
	"./facebook.svg": 1656,
	"./hover.svg": 1018,
	"./info.svg": 96,
	"./instagram.svg": 1976,
	"./logo.svg": 6475,
	"./news.svg": 5387,
	"./next.svg": 7137,
	"./pause.svg": 5834,
	"./play.svg": 170,
	"./plus.svg": 4180,
	"./prev.svg": 7517,
	"./search.svg": 2752,
	"./twitter.svg": 1659,
	"./vimeo.svg": 5368,
	"./youtube.svg": 1841
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6933;